import { useCallback } from 'react'
import { useAuth } from './use-auth'
import { useLocalStorage } from './use-local-storage'

export type UseDismissibleBannerResult = {
  dismissed: boolean
  dismiss: () => void
}

export function useDismissibleBanner(baseKey: string): UseDismissibleBannerResult {
  const { user } = useAuth()
  const storageKey = user ? `${baseKey}:${user.id}` : ''
  const [dismissed, setDismissed] = useLocalStorage<boolean>(storageKey, false)

  const dismiss = useCallback(() => {
    setDismissed(true)
  }, [setDismissed])

  return { dismissed, dismiss }
}
